import { render, staticRenderFns } from "./IlmoitusHallitusListItem.vue?vue&type=template&id=0f320460"
import script from "./IlmoitusHallitusListItem.vue?vue&type=script&lang=js"
export * from "./IlmoitusHallitusListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports